import React from 'react'
import PropTypes from 'prop-types'
import ModalFrameHoc from 'components/Modal/modalFrameHoc'
import AccountCredentialsModal from 'modules/AccountsMarketplace/Category/subcomponents/AccountCredentialsModal'

const AccountMarketCredentials = (props) => {
  const { closeModal, title } = props

  return (
    <ModalFrameHoc {...props} closeModal={closeModal} title={title}>
      <AccountCredentialsModal {...props} closeModal={closeModal} />
    </ModalFrameHoc>
  )
}

export default AccountMarketCredentials

AccountMarketCredentials.propTypes = {
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  meta: PropTypes.object,
  ids: PropTypes.array,
  resource: PropTypes.string.isRequired,
}
